import { BaseRepo } from "./base/BaseRepo";
import { UserDashboardModel } from "@/models/UserDashboardModels";
import { createUserDashboardMigrationManager } from "@/utils/migrations";
import { collection, getDocs, query } from "firebase/firestore";
import { getFirestoreDb } from "@/services/firebase";


// src/repos/RoundRepo.ts
/**
 * Repository for models in the rounds collection
 */
export class UserDashboardsRepo extends BaseRepo<UserDashboardModel> {
    protected collectionName = 'userDashboards';
    protected cacheKeyPrefix = 'userDashboard_';

    constructor() {
        super();
        this.setupMigrations(createUserDashboardMigrationManager());
    }

    /**
     * Find all user dashboards that contain league rounds matching the specified leagueId and dayId
     */
    async findByLeagueDay(leagueId: string, dayId: string): Promise<UserDashboardModel[]> {
        // Since we can't easily query for nested array objects with specific properties,
        // we'll get all user dashboards and filter them in memory
        // This is acceptable since user dashboards are typically not extremely large
        const q = query(collection(getFirestoreDb(), this.collectionName));

        const snapshot = await getDocs(q);
        const dashboards: UserDashboardModel[] = [];

        for (const doc of snapshot.docs) {
            const data = doc.data() as UserDashboardModel;
            if (data) {
                const processedData = await this.processMigrations(data, doc.id);

                // Check if this dashboard has the specific league round
                const leagueRounds = processedData.leagueRounds[leagueId];
                if (leagueRounds) {
                    const matchingRound = leagueRounds.rounds.find(round =>
                        round.setup?.league?.id === leagueId &&
                        round.setup?.league?.dayId === dayId
                    );

                    if (matchingRound) {
                        dashboards.push(processedData);
                    }
                }
            }
        }

        return dashboards;
    }
}